export enum PhysicalActivityFrequency {
  SEDENTARY = 'SEDENTARY',
  ACTIVE = 'ACTIVE',
  VERY_ACTIVE = 'VERY_ACTIVE'
}
